import { FC } from "react";
import { useTranslation } from 'react-i18next';
import { IExamStatsByQuestion } from "../../../models/statistics.model";

interface IProps {
  data: IExamStatsByQuestion[]|undefined;
}

const ExamQuestionTable: FC<IProps> = ({
  data,
}) => {
  const { t } = useTranslation();
  return data?.length
    ? (
      <div className="comm-table__area rowType stats">
        <table>
          <tbody>
            <tr>
              <th>{t('statistics.placementTest.column8')}</th>
              <th>Indicator</th>
              <th>Skill</th>
              <th>Total Qs</th>
              <th>{t('statistics.placementTest.column11')}</th>
            </tr>
            {data?.map((item, index) => (
              <>
                <tr>
                  <td rowSpan={item.skillInfo?.length}>{index + 1}</td>
                  <td rowSpan={item.skillInfo?.length}>
                    {item.indicatorKorName}<br />
                    {item.indicatorEngName}
                  </td>
                  {item.skillInfo?.slice(0,1).map(subitem => (
                    <>
                      <td>{subitem.skillName}</td>
                      <td>{subitem.totalQs}</td>
                      <td>{(subitem.correctAnswerRate<70)?<span style={{color:'red'}}>{subitem.correctAnswerRate.toFixed(1)}</span>:subitem.correctAnswerRate.toFixed(1)}</td>
                    </>
                  ))}
                </tr>
                {item.skillInfo?.slice(1).map(subitem => (
                  <tr>
                    <td>{subitem.skillName}</td>
                    <td>{subitem.totalQs}</td>
                    <td>{(subitem.correctAnswerRate<70)?<span style={{color:'red'}}>{subitem.correctAnswerRate.toFixed(1)}</span>:subitem.correctAnswerRate.toFixed(1)}</td>
                  </tr>
                ))}
              </>
            ))}
          </tbody>
        </table>
      </div>
      )
    : null
}

export default ExamQuestionTable;
